<div class="configurationContainer">
  <div class="header hdr">
    <h5> <span class="animateH5">Configuration</span></h5>
  </div>
  <div class="container-fluid align-items-start configContents">
    <div class="row">
      <div class="col-md-2 offset-md-1 configTab">
        <ul class="nav flex-column nav-pills nav-justified" id="v-pills-tab" role="tablist" aria-orientation="vertical">
          <li class="nav-item jerk-tab-class" [ngClass]="{'tri':tabTriangle==='configtopic'}" (click)="showTriangle('configtopic')">
            <a class="nav-link active tabBtn" id="v-pills-configtopic-tab" data-bs-toggle="tab" data-bs-target="#v-pills-configtopic"
              type="button" role="tab" aria-controls="v-pills-configtopic" aria-selected="true">Topic</a>
          </li>
          <li class="nav-item jerk-tab-class" [ngClass]="{'tri':tabTriangle==='category'}" (click)="showTriangle('category')">
            <a class="nav-link" id="v-pills-configCategory-tab" data-bs-toggle="tab" data-bs-target="#v-pills-configCategory"
              type="button" role="tab" aria-controls="v-pills-configCategory" aria-selected="true">Categorization</a>
          </li>
          <li class="nav-item jerk-tab-class" [ngClass]="{'tri':tabTriangle==='parameter'}" (click)="showTriangle('parameter')">
            <a class="nav-link" id="v-pills-configParameter-tab" data-bs-toggle="tab" data-bs-target="#v-pills-configParameter"
              type="button" role="tab" aria-controls="v-pills-configParameter" aria-selected="true">QA Parameter</a>
          </li>
          <ng-container *ngIf="selectedApps=='email'">
          <li class="nav-item jerk-tab-class" [ngClass]="{'tri':tabTriangle==='mail-auto-reply-config'}" (click)="showTriangle('mail-auto-reply-config')">
            <a class="nav-link" id="mail-auto-reply-config-tab" data-bs-toggle="tab" data-bs-target="#mail-auto-reply-config"
              type="button" role="tab" aria-controls="vmail-auto-reply-config" aria-selected="true">Email Auto Reply</a>
          </li>
          <li class="nav-item jerk-tab-class" [ngClass]="{'tri':tabTriangle==='mail-server-config'}" (click)="showTriangle('mail-server-config')">
            <a class="nav-link" id="mail-server-config-tab" data-bs-toggle="tab" data-bs-target="#mail-server-config"
              type="button" role="tab" aria-controls="mail-server-config" aria-selected="true">Email Server Config</a>
          </li>
         </ng-container>
          <!-- <li class="nav-item jerk-tab-class" [ngClass]="{'tri':tabTriangle==='topic'}" (click)="showTriangle('topic')">
            <a class="nav-link" id="v-pills-home-tab" data-bs-toggle="tab" data-bs-target="#v-pills-home"
              type="button" role="tab" aria-controls="v-pills-home" aria-selected="true">Topic & Keywords</a>
          </li> -->
          <!-- <li class="nav-item jerk-tab-class" [ngClass]="{'tri':tabTriangle==='survey'}"
            (click)="showTriangle('survey')" *ngIf="this.userDetails[0]?.email === 'anandan.chinnalagu@matrixcos.com' ">
            <a class="nav-link" id="v-pills-profile-tab" data-bs-toggle="tab" data-bs-target="#v-pills-profile"
              type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false"
              (click)="getSurveyData()">Survey</a>
          </li> -->
          <!-- <li class="nav-item jerk-tab-class" (click)="getNotificationData()"
            [ngClass]="{'tri':tabTriangle==='notification'}" (click)="showTriangle('notification')">
            <a class="nav-link" id="v-pills-messages-tab" data-bs-toggle="tab" data-bs-target="#v-pills-messages"
              type="button" role="tab" aria-controls="v-pills-messages" aria-selected="false">Notification</a>
          </li> -->
          <!-- <li class="nav-item jerk-tab-class" [ngClass]="{'tri':tabTriangle==='stopword'}"
            (click)="showTriangle('stopword')">
            <a class="nav-link" id="v-pills-settings-tab" data-bs-toggle="tab" data-bs-target="#v-pills-settings"
              type="button" role="tab" aria-controls="v-pills-settings" aria-selected="false"
              (click)="getStopWordData('a', 'tab')">Stop Words</a>
          </li> -->
        </ul>
      </div>
      <div class="col-md-8 tableTab">
        <div class="tab-content" id="v-pills-tabContent">

          <!---Topics List--->
          <div class="tab-pane fade show active" id="v-pills-configtopic" role="tabpanel" aria-labelledby="v-pills-configtopic-tab">
            <div class="card">
              <div class="card-body">
                <div class="tblHead d-flex border-bottom">
                  <div class="firstPart">
                    <h4>Topics
                      <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
                      <span class="sr-only">Loading...</span>
                    </h4>
                  </div>
                  <div class="secondPart">
                    <i class="fa-solid fa-square-plus plusIcon" (click)="showButtonFun()" data-bs-toggle="modal"
                      data-bs-target="#topicConfig" tooltip="Create New Topic" [options]="myOptions"></i>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead class="tblHeadings">
                      <tr>
                        <th>Topic name</th>
                        <th>Type</th>
                        <th>To email</th>
                        <th>Client</th>
                        <th>Option</th> 
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="text-center" *ngIf="topicConfigData.length === 0">
                        <td colspan="10">
                          <p class="noRecord">No Records Found</p>
                      </tr>
                      <tr class="topicKeywordTable" [ngClass]="{'selectedClass':i===tableTrVar}" (click)="tableBack(i)"
                        *ngFor="let result of topicConfigData; index as i;">
                          <td class="tdTopic">{{result.config_name}} <b *ngIf="!result.config_name">-</b></td>
                        <td class="tdKeywords">
                        {{result.call_type}} 
                        </td>
                        
                          <td class="tdOtherKeyword">{{result.to_email}}</td>
                          <td>{{result.client_name}}</td>
                          <td class="tdOtherKeyword">
                          <i class="fa-regular fa-pen-to-square configIcon" (click)="getTopicConfigData(i)"
                            data-bs-toggle="modal" data-bs-target="#topicConfig" tooltip="Edit"
                            [options]="myOptions"></i>
                          <i class="fa-regular fa-trash-can configIcon"
                            data-bs-toggle="modal" data-bs-target="#exampleModal" (click)="justShowIndex(i)"
                            tooltip="Delete" [options]="myOptions"></i>
                          </td>  
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <!---Category List-->
          <div class="tab-pane fade" id="v-pills-configCategory" role="tabpanel" aria-labelledby="v-pills-configCategory-tab">
            <div class="card">
              <div class="card-body">
                <div class="tblHead d-flex border-bottom">
                  <div class="firstPart">
                    <h4>Categorization
                      <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
                      <span class="sr-only">Loading...</span>
                    </h4>
                  </div>
                  <div class="secondPart">
                    <i class="fa-solid fa-square-plus plusIcon" (click)="showButtonFun()" data-bs-toggle="modal"
                      data-bs-target="#configCategory" tooltip="Create New Category" [options]="myOptions"></i>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row mt-1 g-2 align-items-center">
                    <div class="col-3 offset-md-1">
                  <label class="form-label">Topics</label></div>
                  <div class="col-3">
                   <select class="form-select" (change)="selectTopic($event)">
                    <option value="" selected>Select </option> 
                     <option *ngFor="let topics of topicConfigData" value="{{topics['config_id']}}">
                      {{topics['config_name']}}
                     </option>
                   </select>
                     
                  </div>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead class="tblHeadings">
                      <tr>
                        <th>Category Name</th>
                        <th>Category Type</th>
                        <th>Content Type</th>
                        <th>Keywords</th>
                        <th>option</th>
                      </tr>
                    </thead>
                    <tbody>
                      <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i> 
                      <tr class="text-center" *ngIf="categoriesList.length==0">
                        <td colspan="10">
                          <p class="noRecord">No Records Found</p>
                      </tr>
                       <ng-container *ngIf="categoriesList.length > 0">
                        <tr *ngFor="let category of categoriesList; index as i">
                          <td>{{category['category_name']}}</td>
                          <td>{{category['category_type']}}</td>
                          <td>{{category['content_type']}}</td>
                          <td class="tdKeywords">
                            <p appReadMoreExpand [popup]="true" [closeIcon]="'fa-solid fa-xmark'" [toggle]="true" [limit]="20"   [innerHTML]="category?.keywords"></p>
                            <!-- <span appReadMore [toggle]="true" [limit]="150" *ngIf="category?.keywords">{{category?.keywords}} </span> -->
                          </td>
                          <td class="tdOtherKeyword">
                            <i class="fa-regular fa-pen-to-square configIcon" (click)="getTopicConfigData(i)"
                              data-bs-toggle="modal" data-bs-target="#configCategory" tooltip="Edit"
                              [options]="myOptions"></i>
                            <i class="fa-regular fa-trash-can configIcon"
                              data-bs-toggle="modal" data-bs-target="#exampleModal" (click)="justShowIndex(i)"
                              tooltip="Delete" [options]="myOptions"></i>
                            </td>  
                        </tr>
                       </ng-container>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <!---QA Param List-->
          <div class="tab-pane fade" id="v-pills-configParameter" role="tabpanel" aria-labelledby="v-pills-configParameter-tab">
            <div class="card">
              <div class="card-body">
                <div class="tblHead d-flex border-bottom">
                  <div class="firstPart">
                    <h4>QA Parameters
                      <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
                      <span class="sr-only">Loading...</span>
                    </h4>
                  </div>
                  <div class="secondPart">
                    <i class="fa-solid fa-square-plus plusIcon" (click)="showButtonFun()" data-bs-toggle="modal"
                      data-bs-target="#configParameter" tooltip="Create New Category" [options]="myOptions"></i>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row mt-1 g-2 align-items-center">
                    <div class="col-3 offset-md-1">
                  <label class="form-label">Topics</label></div>
                  <div class="col-3">
                   <select class="form-select" (change)="selectTopic($event)">
                    <option value="" selected disabled>Select </option> 
                     <option *ngFor="let topics of topicConfigData" value="{{topics['config_id']}}">
                      {{topics['config_name']}}
                     </option>
                   </select></div>
                   <div class="col-3">
                    <div class="spinner-box" *ngIf="spinner">
                    <div class="three-quarter-spinner"></div>
                    </div>
                   </div>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead class="tblHeadings">
                      <tr>
                        <th>QA Param</th>
                        <th>QA Param Type</th>
                        <!-- <th>Keywords</th> -->
                         <th>Error Type</th>
                        <th>Score</th>
                         <th>option</th> 
                      </tr>
                    </thead>
                    <tbody>
                     
                       
                      <tr class="text-center" *ngIf="qaParameterList.length==0">
                        <td colspan="10">
                          <p class="noRecord">No Records Found</p>
                      </tr>
                       <ng-container *ngIf="qaParameterList.length > 0">
                        <tr *ngFor="let qaParams of qaParameterList; index as i">
                          <td class="tdKeywords">
                            <span appReadMore [toggle]="true" [limit]="50" *ngIf="qaParams?.qa_param">{{qaParams?.qa_param}} </span>
                          </td>
                          <td>{{qaParams?.qa_param_type}}</td>
                          <!-- <td class="tdKeywords">
                            <span appReadMore [toggle]="true" [limit]="150" *ngIf="qaParams?.keywords">{{qaParams?.keywords}} </span>
                          </td> -->
                          <td>{{qaParams?.error_type_name}}</td>
                          <td>{{qaParams['score']}}</td>
                          <td class="tdOtherKeyword">
                            <i class="fa-regular fa-pen-to-square configIcon" (click)="getTopicConfigData(i)"
                              data-bs-toggle="modal" data-bs-target="#configParameter" tooltip="Edit"
                              [options]="myOptions"></i>
                            <i class="fa-regular fa-trash-can configIcon"
                              data-bs-toggle="modal" data-bs-target="#exampleModal" (click)="justShowIndex(i)"
                              tooltip="Delete" [options]="myOptions"></i>
                            </td> 
                        </tr>
                       </ng-container>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
         
          <!-- Survey Tab -->
          <div class="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
            <div class="card surveyCardClass">
              <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
              <span class="sr-only">Loading...</span>
              <div class="card-body">
                <div class="tblHead d-flex border-bottom">
                  <div class="firstPart">
                    <h4>Survey Configuration</h4>
                  </div>
                  <div class="secondPart">
                    <i class="fa-solid fa-square-plus plusIcon" data-bs-toggle="modal" data-bs-target="#newSurveyModal"
                      tooltip="Create New Survey" [options]="myOptions"></i>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table">
                    <thead class="tblHeadings">
                      <tr>
                        <th class="survey-tbl-first-th">survey</th>
                        <th>option</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor=" let result of survyTableData; index as i">
                        <td>{{result.survey_name}}</td>
                        <td class="tdOtherKeyword">
                          <i class="fa-regular fa-pen-to-square configIcon" tooltip="Edit" [options]="myOptions"
                            (click)="sendSurveyIndex(i)" data-bs-toggle="modal" data-bs-target="#newSurveyModal"></i>
                          <i class="fa-regular fa-trash-can configIcon" tooltip="Delete" [options]="myOptions"></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <!-- Notification Tab -->
          <div class="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">
            <div class="card notificationCard">
              <div class="card-body">
                <form [formGroup]="notificationForm">
                  <div class="table-responsive">
                    <table class="table notification-table">
                      <thead class="tblHeadings">
                        <tr>
                          <th class="survey-tbl-first-th">general notification</th>
                          <th>in app</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="border-end">Enable Alert Email notification</td>
                          <td>
                            <div class="form-check form-switch">
                              <input class="form-check-input" formControlName="alert" type="checkbox" role="switch"
                                id="alert">
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="border-end">Enable Completed Email notification</td>
                          <td>
                            <div class="form-check form-switch">
                              <input class="form-check-input" formControlName="complete" type="checkbox" role="switch"
                                id="complete">
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="border-end">Enable Failure Email notification</td>
                          <td>
                            <div class="form-check form-switch">
                              <input class="form-check-input" formControlName="failure" type="checkbox" role="switch"
                                id="failure">
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="card-footer">
                    <button class="btn btn-primary updateBtn" (click)=" updateNotification()"
                      [disabled]="!notificationForm.dirty">Update</button>
                  </div>
                </form>
              </div>
            </div>

          </div>
      

          <!--Mail Autoreply Tab-->
           <div class="tab-pane fade" id="mail-auto-reply-config" role="tabpanel" aria-labelledby="mail-auto-reply-config-tab">
            <div class="card">
              <div class="card-body">
                <div class="tblHead d-flex border-bottom">
                  <div class="firstPart">
                    <h4>Email Auto Reply
                      <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
                      <span class="sr-only">Loading...</span>
                    </h4>
                  </div>
                  <div class="secondPart">
                    <i class="fa-solid fa-square-plus plusIcon" (click)="showButtonFun()" data-bs-toggle="modal"
                      data-bs-target="#MailAutoReply" tooltip="Create New Email Auto Reply" [options]="myOptions"></i>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead class="tblHeadings">
                      <tr>
                        <th>Template Name</th>
                        <th>Reply Timing</th>
                         <th>Reply To</th>
                        <th>Option</th> 
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="text-center" *ngIf="mailAutoReplyData.length === 0 else maildataList">
                        <td colspan="10">
                          <p class="noRecord">No Records Found</p>
                      </tr>
                      <ng-template #maildataList> 
                      <tr class="topicKeywordTable" [ngClass]="{'selectedClass':i===tableTrVar}" (click)="tableBack(i)"
                        *ngFor="let result of mailAutoReplyData; index as i;">
                          <td class="tdTopic">{{result.template_name}} <b *ngIf="!result.template_name">-</b></td>
                        <td class="tdKeywords">
                        {{result.trigger_time}} 
                        </td>
                          <td>{{result.reply_to.replace("_"," ")}}</td>
                          <td class="tdOtherKeyword">
                          <i class="fa-regular fa-pen-to-square configIcon" (click)="getMailAutoReplyConfigData(i)"
                            data-bs-toggle="modal" data-bs-target="#MailAutoReply" tooltip="Edit"
                            [options]="myOptions"></i>
                          <i class="fa-regular fa-trash-can configIcon"
                            data-bs-toggle="modal" data-bs-target="#exampleModal" (click)="justShowIndex(i)"
                            tooltip="Delete" [options]="myOptions"></i>
                          </td>  
                      </tr>
                      </ng-template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>  
           <!--Mail Autoreply Tab-->
           <div class="tab-pane fade" id="mail-server-config" role="tabpanel" aria-labelledby="mail-server-config-tab">
            <div class="card">
              <div class="card-body">
                <div class="tblHead d-flex border-bottom">
                  <div class="firstPart">
                    <h4>Configuration for reading the inbox emails
                      <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
                      <span class="sr-only">Loading...</span>
                    </h4>
                  </div>
                 
                </div>
                <div class="d-flex justify-content-center">
                <div class="col-8 px-3">
                   <div class="row">
                        <div class="col-md-12">
                            <form [formGroup]="mailConfigForm">
                                                                
                                                                    <div class="col-md-12">
                                                                        <div class="form-group">
                                                                            <label class="form-label mandatoryLabel"
                                                                                [ngClass]="{ 'is-invalid': submitted && fmailin['email_id'].errors }">
                                                                                Email Inbox
                                                                                <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
                                                                                  </label>
                                                                            <!-- <input type="email" class="form-control"
                                                                                formControlName="email_id"
                                                                                name="email_id" 
                                                                                placeholder=""> -->
                                                                                 <tag-input formControlName="email_id" class="form-control tagInput-form-control"
                            placeholder="Email Inbox" secondaryPlaceholder="Enter To Add Email" [trimTags]="true"
                            [addOnBlur]="true" [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="email_id"
                            name="from_id" autocomplete="off" [addOnPaste]="true"
                            [pasteSplitPattern]="splitPattern" (onAdd)="onItemAdded($event,'email_id')"></tag-input> 
                                                                            <div *ngIf="submitted && fmailin['email_id'].errors"
                                                                                class="invalid-feedback">
                                                                                <div class="text-danger"
                                                                                    *ngIf="fmailin['email_id'].errors['required']">
                                                                                    Email is required</div>
                                                                            
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-12">
                                                                        <div class="form-group">
                                                                            <label class="form-label mandatoryLabel"
                                                                                [ngClass]="{ 'is-invalid': submitted && fmailin['from_id'].errors }">
                                                                                From Email
                                                                                <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
                                                                              </label>
                                                                             <!-- <input type="text" class="form-control"
                                                                                formControlName="from_id"
                                                                                name="from_id" 
                                                                                placeholder="">   -->
                                                                                 <tag-input formControlName="from_id" class="form-control tagInput-form-control"
                            placeholder="From Email" secondaryPlaceholder="Enter From Email" [trimTags]="true"
                            [addOnBlur]="true" [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="from_id"
                            name="from_id" autocomplete="off" [addOnPaste]="true"
                            [pasteSplitPattern]="splitPattern" (onAdd)="onItemAdded($event,'from_id')"></tag-input>  
                                                                            <div *ngIf="submitted && fmailin['from_id'].errors"
                                                                                class="invalid-feedback">
                                                                                <div class="text-danger"
                                                                                    *ngIf="fmailin['from_id'].errors['required']">
                                                                                    From email is required</div>
                                                                            
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                         <div class="col-md-12">
                                                                        <div class="form-group">
                                                                            <label class="form-label mandatoryLabel"
                                                                                [ngClass]="{ 'is-invalid': submitted && fmailin['exclude_from_id'].errors }">
                                                                                Exclude Email
                                                                                <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
                                                                              </label>
                                                                             <!-- <input type="text" class="form-control"
                                                                                formControlName="from_id"
                                                                                name="from_id" 
                                                                                placeholder="">   -->
                                                                                 <tag-input formControlName="exclude_from_id" class="form-control tagInput-form-control"
                            placeholder="Exclude Email" secondaryPlaceholder="Enter Exclude Email" [trimTags]="true"
                            [addOnBlur]="true" [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="exclude_from_id"
                            name="exclude_from_id" autocomplete="off" [addOnPaste]="true"
                            [pasteSplitPattern]="splitPattern" (onAdd)="onItemAdded($event,'exclude_from_id')"></tag-input>  
                                                                            <div *ngIf="submitted && fmailin['exclude_from_id'].errors"
                                                                                class="invalid-feedback">
                                                                                <div class="text-danger"
                                                                                    *ngIf="fmailin['exclude_from_id'].errors['required']">
                                                                                    Exclude email is required</div>
                                                                            
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    
                                                                
                                                                    <div class="col-md-12">
                                                                    
                                                                        <div class="form-group">
                                                                            <label class="form-label mandatoryLabel"
                                                                                [ngClass]="{ 'is-invalid': submitted && fmailin['app_client_id'].errors }">
                                                                                Application Client Id
                                                                                <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
                                                                              </label>
                                                                                    <div class="input-field new-pass-input-field">
                                                                                        <input type="password" class="form-control"
                                                                                        formControlName="app_client_id"
                                                                                        name="app_client_id" readonly>
                                                                                        <span class="fa {{eyeIcon}} passwordEye"
                                                                                        appPasswordMask></span>
                                                                                    </div>
                                                                            <div *ngIf="submitted && fmailin['app_client_id'].errors"
                                                                                class="invalid-feedback">
                                                                                <div class="text-danger"
                                                                                    *ngIf="fmailin['app_client_id'].errors['required']">
                                                                                    Application Client Id is required</div>
                                                                                
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-md-12">
                                                                        <div class="form-group">
                                                                            <label class="form-label mandatoryLabel"
                                                                                [ngClass]="{ 'is-invalid': submitted && fmailin['app_client_secret'].errors }">
                                                                                Application Client Secret
                                                                                <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
                                                                              </label>
                                                                    

                                                                                <div class="input-field new-pass-input-field">
                                                                                    <input type="password" class="form-control"
                                                                                    formControlName="app_client_secret"
                                                                                    name="app_client_secret" readonly>
                                                                                    <span class="fa {{eyeIcon}} passwordEye"
                                                                                    appPasswordMask></span>
                                                                                </div>
                                                                            <div *ngIf="submitted && fmailin['app_client_secret'].errors"
                                                                                class="invalid-feedback">
                                                                                <div class="text-danger"
                                                                                    *ngIf="fmailin['app_client_secret'].errors['required']">
                                                                                    Application Client Secret is required</div>
                                                                                
                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                    <div class="col-md-12">
                                                                        <div class="form-group">
                                                                            <label class="form-label mandatoryLabel"
                                                                                [ngClass]="{ 'is-invalid': submitted && fmailin['azure_ad_tenant_id'].errors }">
                                                                                Azure Tenant Id
                                                                                <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
                                                                              </label>
                                                                            <!-- <input type="text" class="form-control"
                                                                                formControlName="azure_ad_tenant_id"
                                                                                name="azure_ad_tenant_id" 
                                                                                placeholder=""> -->
                                                                                <div class="input-field new-pass-input-field">
                                                                                    <input type="password" class="form-control"
                                                                                    formControlName="azure_ad_tenant_id"
                                                                                    name="azure_ad_tenant_id" readonly>
                                                                                    <span class="fa {{eyeIcon}} passwordEye"
                                                                                    appPasswordMask></span>
                                                                                </div>
                                                                            <div *ngIf="submitted && fmailin['azure_ad_tenant_id'].errors"
                                                                                class="invalid-feedback">
                                                                                <div class="text-danger"
                                                                                    *ngIf="fmailin['azure_ad_tenant_id'].errors['required']">
                                                                                    Azure Tenant Id is required</div>
                                                                                
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                     <div class="d-flex justify-content-center py-3">
                  <div class="col-10">
                    <div class="required-error">Note: All fields are required.</div>
                  </div>
                </div>
                                                                
                                                                    <div class="d-flex justify-content-center">
                                                                    <div class="col-2 offset-md-1 btnColumn">
                                                                        <button class="btn btn-primary updateBtn"
                                                                            (click)="mailConfig()">Save</button>
                                                                    </div>
                                                                    </div>
                            </form>
                        </div>
                   </div>
                </div>
                </div>
               
              </div>
            </div>
          </div>  
        </div>
      </div>
    </div>
  </div>
    <!-- Delete Modal Window -->
    <div class="modal fade deleteModal" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="exampleModalLabel">
            <ng-container *ngIf="tabTriangle==='configtopic'">
              Delete Topic
            </ng-container> 
            <ng-container *ngIf="tabTriangle==='category'">
              Delete Category
            </ng-container>
            <ng-container *ngIf="tabTriangle==='parameter'">
              Delete QA Parameter
            </ng-container>
            <ng-container *ngIf="tabTriangle==='mail-auto-reply-config'">
              Delete Email Auto Reply
            </ng-container>
            </h4>
            <i class="fa-solid fa-xmark exitIcon" data-bs-dismiss="modal" aria-label="Close"></i>
          </div>
          <div class="modal-body">
            Are you sure you want to delete?
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
            <button type="button" class="btn btn-danger" (click)="deleteTopic(deleteIndex)"
              data-bs-dismiss="modal">Yes</button>
          </div>
        </div>
      </div>
    </div>
    <!--topics form modal window -->
    <!-- <div class="modal fade topicFormModal" data-bs-backdrop="static" data-bs-keyboard="false" id="topicDetails"
      #topicModal>
      <div class="modal-dialog modal-dialog-scrollable modal-lg" [ngClass]="{'full-screen':metricFullscreen}">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Configurations</h4>
            <span>
              <i class="fa metricFullscreen" [ngClass]="{'fa-down-left-and-up-right-to-center':metricFullscreen,'fa-up-right-and-down-left-from-center':!metricFullscreen}"  (click)="metricFullscreen = !metricFullscreen"></i>&nbsp;&nbsp;
              <i class="fa-solid fa-xmark exitIcon" #closebutton data-bs-dismiss="modal" aria-label="Close"
              (click)="exitIconReset()"></i>
            </span>
           
          </div>
          <div class="modal-body">
            <div class="col-md-8 offset-md-2">
              <form class="topicForm" [formGroup]="topicForm">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="call_type" formControlName="call_type"
                        value="inbound" id="inlineRadio1" checked>
                      <label class="form-check-label" for="inlineRadio1">
                        Inbound
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="call_type" formControlName="call_type"
                        value="outbound" id="inlineRadio2">
                      <label class="form-check-label" for="inlineRadio2">
                        Outbound
                      </label>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="expand-btn-class">
                      <button class="btn btn-primary updateBtn" *ngIf="(!expandButtonShow)"
                        (click)="expandTopicsAllTabs('expand')">
                        Expand All
                      </button>
                      <button class="btn btn-primary updateBtn" *ngIf="(expandButtonShow)"
                        (click)="expandTopicsAllTabs('collapse')">
                        Collapse All
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="topic" class="form-label mandatoryLabel">Topic Name
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                  <input type="text" class="form-control" formControlName="config_name" id="topic" name="config_name"
                    placeholder="Enter Your Topic Name" autocomplete="off">
                  <span class="text-danger"
                    *ngIf="topicForm.controls['config_name'].dirty && topicForm.hasError('required','config_name')">Topic Name is
                    required.
                  </span>
                </div>
                <div class="form-group">
                  <div class="accordion" id="accordionPanelsStayOpenExample">
                    <div class="accordion-item accordionClass">
                      <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                        <button class="accordion-button collapsed" #accordionBtn1 (click)="toggleCollapsed('1')"
                          type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne"
                          aria-expanded="false" aria-controls="panelsStayOpen-collapseOne">
                         
                          Keywords / Phrase Configuration <span class="no-data-accordion"
                            *ngIf=" updateBoolean && !topicForm.controls['keywords'].value?.length && !topicForm.controls['alert_words'].value?.length && !topicForm.controls['sensitive_words'].value?.length && !topicForm.controls['hide_words'].value?.length && !topicForm.controls['delete_words'].value?.length">
                            - No Data</span>
                        </button>
                      </h2>
                      <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse"
                        aria-labelledby="panelsStayOpen-headingOne">
                        <div class="accordion-body">
                          <div class="form-group">
                            <label class="form-label">Keywords / Phrase</label>
                            <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                              secondaryPlaceholder="Enter Your Keyword" [trimTags]="true" [addOnBlur]="true"
                              [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" formControlName="keywords"
                              id="keywords" name="keywords" autocomplete="off" [addOnPaste]="true"
                              [pasteSplitPattern]="splitPattern"></tag-input>
                            <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after
                              typing
                              each keyword</span>
                          </div>
                          <div class="form-group">
                            <label class="form-label">Alert Keywords</label>
                            <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                              secondaryPlaceholder="Enter Your Alert Keyword" [addOnBlur]="true" [clearOnBlur]="true"
                              [modelAsStrings]="true" theme="minimal" formControlName="alert_words" id="alert_words"
                              name="alert_words" autocomplete="off" [addOnPaste]="true"
                              [pasteSplitPattern]="splitPattern"></tag-input>
                            <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after
                              typing
                              each keyword</span>
                          </div>
                          <div class="form-group">
                            <label class="form-label">Sensitive Keywords</label>
                            <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                              secondaryPlaceholder="Enter Your Sensitive Keyword" [addOnBlur]="true"
                              [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal"
                              formControlName="sensitive_words" id="sensitive_words" name="sensitive_words"
                              autocomplete="off" [addOnPaste]="true" [pasteSplitPattern]="splitPattern"></tag-input>
                            <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after
                              typing
                              each keyword</span>
                          </div>
                          <div class="form-group">
                            <label class="form-label">Hide Keywords</label>
                            <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                              secondaryPlaceholder="Enter Your Hide Keyword" [addOnBlur]="true" [clearOnBlur]="true"
                              [modelAsStrings]="true" theme="minimal" formControlName="hide_words" id="hide_words"
                              name="hide_words" autocomplete="off" [addOnPaste]="true"
                              [pasteSplitPattern]="splitPattern"></tag-input>
                            <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after
                              typing
                              each keyword</span>
                          </div>
                          <div class="form-group">
                            <label class="form-label">Delete Keywords</label>
                            <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                              secondaryPlaceholder="Enter Your Delete Keyword" [addOnBlur]="true" [clearOnBlur]="true"
                              [modelAsStrings]="true" theme="minimal" formControlName="delete_words" id="delete_words"
                              name="delete_words" autocomplete="off" [addOnPaste]="true"
                              [pasteSplitPattern]="splitPattern"></tag-input>
                            <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after
                              typing
                              each keyword</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item accordionClass">
                      <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                        <button class="accordion-button collapsed" type="button" #accordionBtn2
                          (click)="toggleCollapsed('2')" data-bs-toggle="collapse"
                          data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false"
                          aria-controls="panelsStayOpen-collapseTwo">
                        
                          Modulation Configuration <span class="no-data-accordion"
                            *ngIf=" updateBoolean && !topicForm.controls['pause_fillers'].value?.length && !topicForm.controls['positive_fillers'].value?.length">
                            - No Data</span>
                        </button>
                      </h2>
                      <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse"
                        aria-labelledby="panelsStayOpen-headingTwo">
                        <div class="accordion-body">
                          <div class="form-group">
                            <label class="form-label">Negative Modulation</label>
                            <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                              secondaryPlaceholder="Enter Your Keyword" formControlName="pause_fillers"
                              id="pause_fillers" name="pause_fillers" autocomplete="off" [addOnBlur]="true"
                              [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" [addOnPaste]="true"
                              [pasteSplitPattern]="splitPattern"></tag-input>
                            <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after
                              typing
                              each keyword</span>
                          </div>
                          <div class="form-group">
                            <label class="form-label">Positive Modulation</label>
                            <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                              secondaryPlaceholder="Enter Your Keyword" formControlName="positive_fillers"
                              id="positive_fillers" name="positive_fillers" autocomplete="off" [addOnBlur]="true"
                              [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" [addOnPaste]="true"
                              [pasteSplitPattern]="splitPattern"></tag-input>
                            <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after
                              typing
                              each keyword</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item accordionClass">
                      <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                        <button class="accordion-button collapsed" #accordionBtn3 (click)="toggleCollapsed('3')"
                          type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree"
                          aria-expanded="false" aria-controls="panelsStayOpen-collapseThree" id="acBtnCall">
                         
                          Email Category Configuration <span class="no-data-accordion"
                            *ngIf="updateBoolean && qa_category.length === 0"> - No Data</span>
                          <span class="formArrayValidationClass">
                            <i *ngIf="qa_category.length > 0  && qa_category.valid" class="fa fa-check"
                              aria-hidden="true"></i>
                            <i *ngIf="qa_category.length > 0 && qa_category.invalid" class="fa fa-exclamation"
                              aria-hidden="true"></i>
                          </span>
                        </button>
                      </h2>
                      <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse"
                        aria-labelledby="panelsStayOpen-headingThree">
                        <div class="accordion-body">
                          <ng-container formArrayName="qa_category">
                            <ng-container *ngFor="let lessonForm of qa_category.controls; index as i">
                              <div class="card border" *ngIf="showCard && qa_category.length > 0">
                                <div class="form-group" [formGroupName]="i">
                                  <div class="form-group">
                                    <label class="form-label mandatoryLabel">Category <i
                                        class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <input type="text" formControlName="category" class="form-control" id="category"
                                      name="category" placeholder="Enter Category Name">
                                  </div>
                                  <div class="form-group">
                                    <label class="form-label mandatoryLabel">Keywords <i
                                        class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                                      secondaryPlaceholder="Enter Your Keyword" formControlName="keywords" id="keywords"
                                      name="keywords" autocomplete="off" [addOnBlur]="true" [clearOnBlur]="true"
                                      [modelAsStrings]="true" theme="minimal" [addOnPaste]="true"
                                      [pasteSplitPattern]="splitPattern"></tag-input>
                                  </div>
                                  <div class="form-group callCategoryCheck">
                                    <div class="row">
                                      <div class="col-md-5">
                                        <label class="form-label mandatoryLabel">Color <i
                                            class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                        <select name="color" formControlName="color" id="color" class="form-select">
                                         
                                          <option value="#52b788">Green</option>
                                          <option value="#e5383b">Red</option>
                                          <option value="#fdc500">Yellow</option>
                                        </select>
                                      </div>
                                      <div class="col-md-2 offset-md-3">
                                        <div class="form-check form-switch" *ngIf="updateBoolean">
                                          <label class="form-check-label" for="active">Metric Active</label>
                                          <input class="form-check-input" type="checkbox" formControlName="active"
                                            name="active" id="active">
                                        </div>
                                        <button type="button" class="btn btn-danger callBtn"
                                          (click)="deletecall_category(i)" *ngIf="!updateBoolean">Remove</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                          </ng-container>
                          <div class="callBtn2 d-flex justify-content-end">
                            <button class="btn btn-primary updateBtn" type="button" (click)="addcall_category()">Add
                              More</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item accordionClass">
                      <h2 class="accordion-header" id="panelsStayOpen-headingFour">
                        <button class="accordion-button collapsed" #accordionBtn4 (click)="toggleCollapsed('4')"
                          type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFour"
                          aria-expanded="false" aria-controls="panelsStayOpen-collapseFour">
                       
                           QA Parameter <span class="no-data-accordion"
                            *ngIf="updateBoolean && qa_params.length === 0"> - No Data</span>
                          <span class="formArrayValidationClass">
                            <i *ngIf="qa_params.length > 0 && qa_params.valid" class="fa fa-check" aria-hidden="true"></i>
                            <i *ngIf="qa_params.length > 0 && qa_params.invalid" class="fa fa-exclamation"
                              aria-hidden="true"></i>
                          </span>
                        </button>
                      </h2>
                      <div id="panelsStayOpen-collapseFour" class="accordion-collapse collapse"
                        aria-labelledby="panelsStayOpen-headingFour">
                        <div class="accordion-body">
                          <ng-container formArrayName="qa_params">
                            <ng-container *ngFor="let lessonForm of qa_params.controls; index as i">
                              <div class="card border" *ngIf="showCard && qa_params.length > 0">
                                <div class="form-group" [formGroupName]="i">
                                  <div class="form-group">
                                    <label class="form-label mandatoryLabel">Category <i
                                        class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <input type="text" formControlName="category" class="form-control" id="category"
                                      name="category" placeholder="Enter Category Name">
                                  </div>
                                  <div class="form-group">
                                    <label class="form-label mandatoryLabel">Keywords <i
                                        class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                                      secondaryPlaceholder="Enter Your Keyword" formControlName="keywords" id="keywords"
                                      name="keywords" autocomplete="off" [addOnBlur]="true" [clearOnBlur]="true"
                                      [modelAsStrings]="true" theme="minimal" [addOnPaste]="true"
                                      [pasteSplitPattern]="splitPattern"></tag-input>
                                  </div>
                                  <div class="form-group">
                                    <label class="form-label mandatoryLabel">Score <i
                                        class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <input type="number" onkeydown="return event.keyCode !== 69" formControlName="score"
                                      class="form-control scoreInput" id="score" name="score" placeholder="Enter Score">
                                  </div>
                                 
                                  <div class="form-group metricsCheck">
                                    <ng-container>
                                    <div class="row border-top">
                                      <div class="col-md-4">
                                        <div class="form-check form-switch">
                                          <label class="form-check-label" for="flexSwitchCheckDefault">Score
                                            Weightage</label>
                                          <input class="form-check-input" type="checkbox" formControlName="weitage"
                                            name="weitage" id="weitage">
                                        </div>
                                      </div>
                                      <div class="col-md-4 offset-md-2" *ngIf="updateBoolean">
                                        <div class="form-check form-switch">
                                          <label class="form-check-label" for="active">Metric Active</label>
                                          <input class="form-check-input" type="checkbox" formControlName="active"
                                            name="active" id="active">
                                        </div>
                                      </div>
                                      <div class="col-md-4" [ngClass]="{'offset-md-2':!updateBoolean}">
                                        <label class="form-label mandatoryLabel">Error Type</label>
                                        <select class="form-select" style="width: auto;" name="type_error" formControlName="type_error">
                                          <option value="fatal">Fatal</option>
                                          <option value="business-critical">Business Critical</option>
                                          <option value="customer-critical">Customer Critical</option>
                                          <option value="semi-critical">Semi Critical</option>
                                          <option value="compliance-critical">Compliance Critical</option>
                                          <option value="non-fatal">Non-Fatal</option>
                                          <option value="non-critical">Non-Critical</option>
                                          <option value="ding">Ding</option>
                                          <option value="na">NA</option>
                                        </select>
                                      </div>
                                      <div class="col-md-4" *ngIf="!updateBoolean">
                                        <div class="form-check form-switch">
                                          <label class="form-check-label" for="free_score">Auto Score</label>
                                          <input class="form-check-input" type="checkbox" id="free_score"
                                            name="free_score" formControlName="free_score">
                                        </div>
                                      </div>
                                      <div class="col-md-4 offset-md-2" *ngIf="updateBoolean">
                                        <div class="form-check form-switch">
                                          <label class="form-check-label" for="free_score">Auto Score</label>
                                          <input class="form-check-input" type="checkbox" id="free_score"
                                            formControlName="free_score" name="free_score">
                                        </div>
                                      </div>
                                      <div class="col-md-4 offset-md-2" *ngIf="!updateBoolean">
                                        <div class="form-check form-switch">
                                          <label class="form-check-label" for="negative_question">Negative
                                            Parameter</label>
                                          <input class="form-check-input" type="checkbox" id="negative_question"
                                            formControlName="negative_question" name="negative_question">
                                        </div>
                                      </div>
                                      <div class="col-md-4 " *ngIf="updateBoolean">
                                        <div class="form-check form-switch">
                                          <label class="form-check-label" for="negative_question">Negative
                                            Parameter</label>
                                          <input class="form-check-input" value="false" type="checkbox"
                                            id="negative_question" formControlName="negative_question"
                                            name="negative_question">
                                        </div>
                                      </div>
                                      <div class="col-md-4 offset-md-8" *ngIf="!updateBoolean">
                                        <button type="button" class="btn btn-danger callBtn"
                                          (click)="deletemetrics(i)">Remove</button>
                                      </div>
                                    </div>
                                   </ng-container>
                                   
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                          </ng-container>
                          <div class="callBtn2 d-flex justify-content-end">
                            <button class="btn btn-primary updateBtn" type="button" (click)="addmetrics()">Add
                              More</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="to_email" class="form-label">To Email</label>
                  <input type="text" formControlName="to_email" class="form-control" id="to_email"
                    name="to_email" placeholder="Enter Email">
                </div>

              </form>
            </div>

          </div>
          <div class="modal-footer">
            <div class="form-group topicBtnGroup">
              <button class="btn btn-info cancelBtn" type="reset" data-bs-dismiss="modal" aria-label="Close"
                (click)="exitIconReset()">Cancel</button>
              <button *ngIf="!showButton" class="btn btn-primary updateBtn" type="button"
                (click)="onSubmit()">Save</button>
              <button [disabled]="!topicForm.dirty" *ngIf="showButton" class="btn btn-primary updateBtn" type="button"
                (click)="updateForm()">Update</button>
            </div>
          </div>
        </div>
      </div>
    </div> -->
 
  <!-- stop word modal -->
  <!-- <div class="modal fade" id="stopWordModal" tabindex="-1" aria-labelledby="stopWordModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="stopWordModalLabel" *ngIf="stopWordShowInput === 'edit' ">Edit Stop Words</h4>
          <h4 class="modal-title" id="stopWordModalLabel" *ngIf="stopWordShowInput === 'create' ">Create Stop Words
          </h4>
          <i class="fa-solid fa-xmark exitIcon" data-bs-dismiss="modal" aria-label="Close" (click)="exitStopWord()"></i>
        </div>
        <div class="modal-body">
          <input *ngIf="stopWordShowInput === 'edit' " type="text" (ngModelChange)="changeInputStopWord()"
            class="form-control" [(ngModel)]="stopWords">
          <div class="form-group" *ngIf="stopWordShowInput === 'create' ">
            <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
              secondaryPlaceholder="Enter Your Keyword" [addOnBlur]="true" [clearOnBlur]="true" [modelAsStrings]="true"
              theme="minimal" (ngModelChange)="changeInputStopWord()" [(ngModel)]="stopWords2" autocomplete="off"
              [addOnPaste]="true" [pasteSplitPattern]="splitPattern"></tag-input>
            <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after
              typing
              each keyword</span>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary cancelBtn" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary updateBtn" data-bs-dismiss="modal" (click)="updateStopWordFun()"
            [disabled]="stopWordBtnShow"> <span *ngIf="stopWordShowInput === 'edit' ">Update</span> <span
              *ngIf="stopWordShowInput === 'create' ">Save</span> </button>
        </div>
      </div>
    </div>
  </div> -->
  <!-- stop word Delete Modal Window -->
  <!-- <div class="modal fade deleteModal" id="stopWordDeleteModal" tabindex="-1" aria-labelledby="stopWordDeleteModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="stopWordDeleteModalLabel">Delete Stop Word</h4>
          <i class="fa-solid fa-xmark exitIcon" data-bs-dismiss="modal" aria-label="Close"></i>
        </div>
        <div class="modal-body">
          Are you sure, you want to delete?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
          <button type="button" class="btn btn-danger" (click)="DeleteStopWordFun(getStopWordIndex)"
            data-bs-dismiss="modal">Yes</button>
        </div>
      </div>
    </div>
  </div> -->
  <!-- New Survey create modal -->
  <!-- <div class="modal fade newSurveyModalClass" id="newSurveyModal" data-bs-backdrop="static" data-bs-keyboard="false"
    tabindex="-1" aria-labelledby="newSurveyModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="newSurveyModalLabel">Survey Details</h4>
          <i class="fa-solid fa-xmark exitIcon" data-bs-dismiss="modal" aria-label="Close"
            (click)="exitSurveyModal()"></i>
        </div>
        <div class="modal-body">
          <div class="container-fluid">
            <form [formGroup]="surveyForm">
              <div class="form-group">
                <label for="topic" class="form-label mandatoryLabel">Survey Name
                  <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                <input type="text" class="form-control" formControlName="survey_name" id="survey_name"
                  name="survey_name" placeholder="Enter Your Survey Name">
                <span class="text-danger"></span>
              </div>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12">
                    <div formArrayName="question_answers">
                      <div *ngFor="let lessonForm of surveyFirstSection().controls; let i=index">
                        <div class="form-group form-array-form-group" [formGroupName]="i">
                          <div class="form-group d-flex">
                            <input type="text" class="form-control" formControlName="question" id="question"
                              name="question" placeholder="Enter your question">
                            <span class="text-danger"></span>
                            <i class="fa-solid fa-circle-xmark delete-input-exit-icon" (click)="deleteQuestionInput(i)"
                              tooltip="Delete" [options]="myOptions"></i>
                          </div>
                          <div formArrayName="answers">
                            <div *ngFor="let lessonForm2 of surveySecondSection(i).controls; let j=index">
                              <div class="form-group form-array-form-group answer-question-input-class"
                                [formGroupName]="j">
                                <div class="col-md-10">
                                  <div class="form-group qa-form-group d-flex">
                                    <input type="text" class="form-control" formControlName="answer" id="answer"
                                      name="answer" placeholder="Enter your answer">
                                    <i class="fa-solid fa-circle-xmark delete-input-exit-icon" *ngIf="j>0"
                                      (click)="deleteQuestionAnswerInputs(j, i)" tooltip="Delete"
                                      [options]="myOptions"></i>
                                  </div>
                                </div>
                                <div class="col-md-5">
                                  <div class="form-group qa-form-group">
                                    <input type="number" class="form-control" formControlName="score" id="score"
                                      name="score" placeholder="Enter your score"
                                      onkeydown="return event.keyCode !== 69">
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12 newSurveyModalBtnClass">
                            <button class="btn btn-primary updateBtn add-more-choices-btn"
                              (click)="addSurveySecondSection(i)" #addSurveySecondSectionId><i
                                class="fa fa-plus-circle addMoreIconModal" aria-hidden="true"></i> Add More
                              Choices</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="col-md-12 newSurveyModalBtnClass">
                  <button class="btn btn-primary updateBtn" (click)="addSurveyFirstSection()"><i
                      class="fa fa-plus-circle addMoreIconModal" aria-hidden="true"></i> Add new question</button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary cancelBtn" (click)="exitSurveyModal()"
            data-bs-dismiss="modal">Cancel</button>
            <button type="button" *ngIf="!showButton" class="btn btn-primary updateBtn" data-bs-dismiss="modal">Create Survey</button>
            <button type="button" *ngIf="showButton" class="btn btn-primary updateBtn" data-bs-dismiss="modal">Update Survey</button>
        </div>
      </div>
    </div>
  </div> -->



   <!--topics form modal window -->
   <div class="modal fade topicFormModal" data-bs-backdrop="static" data-bs-keyboard="false" id="topicConfig"
   #topicModal>
   <div class="modal-dialog modal-dialog-scrollable modal-lg" [ngClass]="{'full-screen':metricFullscreen}">
     <div class="modal-content">
       <div class="modal-header">
         <h4 class="modal-title">Topic Configurations</h4>
         <span>
           <i class="fa metricFullscreen" [ngClass]="{'fa-down-left-and-up-right-to-center':metricFullscreen,'fa-up-right-and-down-left-from-center':!metricFullscreen}"  (click)="metricFullscreen = !metricFullscreen"></i>&nbsp;&nbsp;
           <i class="fa-solid fa-xmark exitIcon" #closebutton data-bs-dismiss="modal" aria-label="Close"
           (click)="exitIconReset()"></i>
         </span>
        
       </div>
       <div class="modal-body">
         <div class="d-flex justify-content-center">
          <div class="col-8">
           <form class="topicForm" [formGroup]="topicConfigForm">
             <div class="row">
               <div class="col-md-6">
                <!-- <ng-container *ngIf="callTypeList.length > 0">
                  <ng-container  *ngFor="let calls of callTypeList">
                    <ng-container *ngIf="calls?.is_active">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="call_type_id" formControlName="call_type_id"
                          [value]="calls['id']" id="inlineRadio{{calls['id']}}"   [checked]="checkboxvalue==calls['id']">
                        <label class="form-check-label"  for="inlineRadio{{calls['id']}}">
                          {{calls['name']}}
                        </label>
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>   
                <span class="text-danger"
                 *ngIf="topicConfigForm.controls['call_type_id'].invalid && topicConfigForm.controls['call_type_id'].touched">Type required
                 required.
               </span>-->
                 <!-- <div class="form-check form-check-inline">
                   <input class="form-check-input" type="radio" name="call_type_id" formControlName="call_type_id"
                     value="1" id="inlineRadio1" [checked]="ValidateChecked_callType('1')">
                   <label class="form-check-label" for="inlineRadio1">
                     Inbound
                   </label>
                 </div>
                 <div class="form-check form-check-inline">
                   <input class="form-check-input" type="radio" name="call_type_id" formControlName="call_type_id"
                     value="2" id="inlineRadio2" [checked]="ValidateChecked_callType('2')">
                   <label class="form-check-label" for="inlineRadio2">
                     Outbound
                   </label>
                 </div> -->
               </div>
               <div class="col-md-6">
             
               </div>
             </div>
             <div class="form-group row">
              <div class="col-5">
               <label for="topic" class="form-label mandatoryLabel">Topic Name
                 <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
                </label></div>
                 <div class="col-7">
               <input type="text" class="form-control" formControlName="config_name" id="config_name" name="config_name"
                 placeholder="Enter Your Topic Name" autocomplete="off">
               <span class="text-danger"
                 *ngIf="topicConfigForm.controls['config_name'].invalid && topicConfigForm.controls['config_name'].touched || topicConfigForm.controls['config_name'].hasError('pattern')">Topic Name is
                 required.
               </span>
               </div>
             </div>
             <div class="form-group row">
              <div class="col-5">
               <label class="form-label">Client 
                <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
              </label></div>
               <div class="col-7">
               <select formControlName="client_id" class="form-select">
                  <option value="" selected>Select </option> 
               <ng-container *ngIf="clientList.length > 0">
                <option *ngFor="let client of clientList" value="{{client['id']}}">{{client['name']}}</option>
              </ng-container>
               </select>
               <span class="text-danger"
                 *ngIf="topicConfigForm.controls['client_id'].invalid && topicConfigForm.controls['client_id'].touched">Client is
                 required.
               </span>
              </div>
             </div>
             <div class="form-group row">
              <div class="col-5">
               <label for="to_email" class="form-label">To Email 
                <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
              </label>
               </div>
               <div class="col-7">
               <input type="text" formControlName="to_email" class="form-control" id="to_email"
                 name="to_email" placeholder="Enter Email">
                 <span class="text-danger"
                 *ngIf="topicConfigForm.controls['to_email'].touched && topicConfigForm.controls['to_email'].invalid">Email is
                 required.
               </span></div>
             </div>

           </form>
           </div>
           
         </div>
          <div class="d-flex justify-content-center">
            <div class="col-8">
              <div class="form-group row">
              <div class="col">
                  <div class="required-error">Note: All fields are required.</div>
                </div>
              </div>
            </div>
           </div> 

       </div>
       <div class="modal-footer">
       
         <div class="form-group topicBtnGroup">
           <button class="btn btn-info cancelBtn" type="reset" data-bs-dismiss="modal" aria-label="Close"
             (click)="exitIconReset()">Cancel</button>
           <button *ngIf="!showButton" class="btn btn-primary updateBtn" type="button"
             (click)="topicConfigFormonSubmit()">Save</button>
           <button [disabled]="!topicConfigForm.dirty" *ngIf="showButton" class="btn btn-primary updateBtn" type="button"
             (click)="topicConfigFormonSubmit()">Update</button>
         </div>
       </div>
     </div>
   </div>
   </div>


    <!--Category form modal window -->
    <div class="modal fade categoryFormModal" data-bs-backdrop="static" data-bs-keyboard="false" id="configCategory"
      #topicModal>
      <div class="modal-dialog modal-dialog-scrollable modal-lg" [ngClass]="{'full-screen':metricFullscreen}">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Category Configurations</h4>
            <span>
              <i class="fa metricFullscreen" [ngClass]="{'fa-down-left-and-up-right-to-center':metricFullscreen,'fa-up-right-and-down-left-from-center':!metricFullscreen}"  (click)="metricFullscreen = !metricFullscreen"></i>&nbsp;&nbsp;
              <i class="fa-solid fa-xmark exitIcon" #closebutton data-bs-dismiss="modal" aria-label="Close"
              (click)="exitIconReset()"></i>
            </span>
          </div>
          <div class="modal-body">
            <div class="d-flex justify-content-center">
             <div class="col-10">
             
              <form class="topicForm" [formGroup]="categoryConfigForm">
                   
                  <div class="row">
                      <div class="col-3">
                         <label class="form-label">Topics 
                           <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i>   -->
                        </label>
                      </div>
                      <div class="col-8">
                        <select class="form-select" formControlName="config_id">
                          
                           <ng-container *ngIf="topicConfigData.length > 0">
                          <option *ngFor="let topics of topicConfigData" value="{{topics['config_id']}}">
                           {{topics['config_name']}}
                          </option></ng-container>
                        </select>
                        <span class="text-danger"
                        *ngIf="categoryConfigForm.controls['config_id'].invalid && categoryConfigForm.controls['config_id'].touched">Topic is
                        required.
                      </span>
                      </div>
                  </div>
                  <div class="row mt-1">
                    <div class="col-3">
                      <label class="form-label">Category 
                          <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i>   -->
                      </label>
                   </div>
                   <div class="col-8">
                       <input type="text" class="form-control" formControlName="category_name">
                       <span class="text-danger"
                       *ngIf="categoryConfigForm.controls['category_name'].value=='' && categoryConfigForm.controls['category_name'].touched">Category is
                       required.
                     </span>
                       <span class="text-danger"
                      *ngIf="categoryConfigForm.controls['category_name'].value!='' && categoryConfigForm.controls['category_name'].hasError('pattern')">Enter valid category name.
                      
                    </span>
                   </div>
                  </div>
                  <div class="row mt-1">
                    <div class="col-3">
                      <label class="form-label">Category Type 
                        <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
                      </label>
                   </div>
                   <div class="col-8">
                       
                       <select name="category_type" (change)="ValidateCategoryType($event,categoryConfigForm)" formControlName="category_type" class="form-select">
                        <!-- <option value="" disabled selected>Choose color</option> -->
                        <!-- <option value="" selected>---Select---</option> 
                         <option value="" selected>Select </option> -->

                        <option value="Keyword">Keyword</option>
                        <option value="AI">AI</option>
                      </select>
                      <span class="text-danger"
                      *ngIf="categoryConfigForm.controls['category_type'].invalid && categoryConfigForm.controls['category_type'].touched">Category Type is
                      required.
                    </span>
                   
                   </div>
                  </div>
                  <div class="row mt-1">
                    <div class="col-3">
                      <label class="form-label">Content Type 
                        <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
                      </label>
                   </div>
                   <div class="col-8">
                      <select name="content_type" formControlName="content_type" class="form-select">
                        <!-- <option value="" disabled selected>Choose color</option> -->
                        <!-- <option value="" selected>---Select---</option> -->
                         <option value="All">All</option>
                        <option value="Agent Response">Agent Response</option>
                        <option value="Customer Mail">Customer Mail</option>
                        <option value="Subject">Subject</option>
                      </select>
                      <span class="text-danger"
                      *ngIf="categoryConfigForm.controls['content_type'].invalid && categoryConfigForm.controls['content_type'].touched">Content Type is
                      required.
                    </span>
                   </div>
                  </div>
                  <div class="row mt-1">
                    <div class="col-3">
                      <label class="form-label">Color 
                        <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
                      </label>
                   </div>
                   <div class="col-8">
                    <select name="color" formControlName="color" id="color" class="form-select">
                      <!-- <option value="" disabled selected>Choose color</option> -->
                      <!-- <option value="" selected>---Select---</option> -->
                       
                      <option value="#52b788">Green</option>
                      <option value="#e5383b">Red</option>
                      <option value="#fdc500">Yellow</option>
                    </select>
                    <span class="text-danger"
                    *ngIf="categoryConfigForm.controls['color'].invalid && categoryConfigForm.controls['color'].touched">Color is
                    required.
                  </span>
                   </div>
                  </div>
                  <div class="row mt-1" *ngIf="categoryConfigForm.value['category_type'] =='Keyword' ">
                    <div class="col-3">
                       <label class="form-label">Keywords
                        <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
                      </label>
                    </div>
                    <div class="col-8">
                      <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                      secondaryPlaceholder="Enter Your Keyword" formControlName="keywords" id="keywords"
                      name="keywords" autocomplete="off" [addOnBlur]="true" [clearOnBlur]="true"
                      [modelAsStrings]="true" theme="minimal" [addOnPaste]="true"
                      [pasteSplitPattern]="splitPattern"></tag-input>
                      <span class="text-danger"
                      *ngIf="categoryConfigForm.controls['keywords'].invalid && categoryConfigForm.controls['keywords'].touched">Keyword(s) required.
                    </span>
                    </div>
                  </div>
              </form>
            </div>
            </div>
                <div class="d-flex justify-content-center">
                <div class="col-10 py-2">
                  <div class="required-error">Note: All fields are required.</div>
                  </div>
              </div> 
          </div>
          <div class="modal-footer">
            <div class="form-group topicBtnGroup">
              <button class="btn btn-info cancelBtn" type="reset" data-bs-dismiss="modal" aria-label="Close"
                (click)="exitIconReset()">Cancel</button>
              <button *ngIf="!showButton" class="btn btn-primary updateBtn" type="button"
                (click)="categoryConfigFormonSubmit()">Save</button>
              <button [disabled]="!categoryConfigForm.dirty" *ngIf="showButton" class="btn btn-primary updateBtn" type="button"
                (click)="categoryConfigFormonSubmit()">Update</button>
            </div>
          </div>
        </div>
      </div>        
    </div>


     <!--QA Parameter form modal window -->
     <div class="modal fade parameterFormModal" data-bs-backdrop="static" data-bs-keyboard="false" id="configParameter"
     #topicModal>
     <div class="modal-dialog modal-dialog-scrollable modal-lg" [ngClass]="{'full-screen':metricFullscreen}">
       <div class="modal-content">
         <div class="modal-header">
           <h4 class="modal-title">QA Parameter Configurations</h4>
           <span>
             <i class="fa metricFullscreen" [ngClass]="{'fa-down-left-and-up-right-to-center':metricFullscreen,'fa-up-right-and-down-left-from-center':!metricFullscreen}"  (click)="metricFullscreen = !metricFullscreen"></i>&nbsp;&nbsp;
             <i class="fa-solid fa-xmark exitIcon" #closebutton data-bs-dismiss="modal" aria-label="Close"
             (click)="exitIconReset()"></i>
           </span>
         </div>
         <div class="modal-body">
          <div class="d-flex justify-content-center">
           <div class="col-8">
             <form class="topicForm" [formGroup]="qaParamConfigForm">
                  
                 <div class="row">
                     <div class="col-4">
                        <label class="form-label">Topics <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                     </div>
                     <div class="col-6">
                       <select class="form-select" formControlName="config_id">
                         <!-- <option value="" selected>---Select---</option> -->
                         
                         <option *ngFor="let topics of topicConfigData" value="{{topics['config_id']}}">
                          {{topics['config_name']}}
                         </option>
                       </select>
                       <span class="text-danger"
                        *ngIf="qaParamConfigForm.controls['config_id'].invalid && qaParamConfigForm.controls['config_id'].touched">Topic is
                        required.
                      </span>
                     </div>
                 </div>
                 <div class="row mt-1">
                   <div class="col-4">
                     <label class="form-label">QA Param<i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                  </div>
                  <div class="col-6">
                      <input type="text" class="form-control" formControlName="qa_param">
                      <span class="text-danger"
                        *ngIf="qaParamConfigForm.controls['config_id'].invalid && qaParamConfigForm.controls['config_id'].touched">QA Param is
                        required.
                      </span>
                  </div>
                 </div>
                 <div class="row mt-1">
                   <div class="col-4">
                     <label class="form-label">QA Param Type <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                  </div>
                  <div class="col-6">
                      
                      <select name="qa_param_type" formControlName="qa_param_type" (change)="ValidateCategoryType($event,qaParamConfigForm)" class="form-select">
                       <!-- <option value="" disabled selected>Choose color</option> -->
                       <!-- <option value="" selected>---Select---</option> -->
                       
                       <option value="Keyword">Keyword</option>
                       <option value="AI">AI</option>
                     </select>
                     <span class="text-danger"
                        *ngIf="qaParamConfigForm.controls['config_id'].invalid && qaParamConfigForm.controls['config_id'].touched">QA Param Type is
                        required.
                      </span>
                  </div>
                 </div>
                 <div class="row mt-1">
                   <div class="col-4">
                     <label class="form-label">Content Type <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                  </div>
                  <div class="col-6">
                     <select name="content_type" formControlName="content_type" class="form-select">
                       <!-- <option value="" disabled selected>Choose color</option> -->
                       <!-- <option value="" selected>---Select---</option> -->
                      <option value="All">All</option>
                       <option value="Agent Response">Agent Response</option>
                       <option value="Customer Mail">Customer Mail</option>
                       <option value="Subject">Subject</option>
                     </select>
                     <span class="text-danger"
                        *ngIf="qaParamConfigForm.controls['config_id'].invalid && qaParamConfigForm.controls['config_id'].touched">Content Type is
                        required.
                      </span>
                  </div>
                 </div>
                 <div class="row mt-1">
                   <div class="col-4">
                     <label class="form-label">Color <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                  </div>
                  <div class="col-6">
                   <select name="color" formControlName="color" id="colors" class="form-select">
                     <!-- <option value="" disabled selected>Choose color</option> -->
                     <!-- <option value="" selected>---Select---</option> -->
                    
                     <option value="#52b788">Green</option>
                     <option value="#e5383b">Red</option>
                     <option value="#fdc500">Yellow</option>
                   </select>
                   <span class="text-danger"
                        *ngIf="qaParamConfigForm.controls['config_id'].invalid && qaParamConfigForm.controls['config_id'].touched">Color is
                        required.
                      </span>
                  </div>
                 </div>
                 <div class="row mt-1">
                  <div class="col-4">
                    <label class="form-label">Score <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                 </div>
                 <div class="col-6">
                    <input type="number" formControlName="score" class="form-control">
                    <span class="text-danger"
                    *ngIf="qaParamConfigForm.controls['score'].invalid && qaParamConfigForm.controls['score'].touched">Score is
                    required.
                  </span>
                 </div>
                </div>
                <div class="row mt-1" *ngIf="qaParamConfigForm.value['qa_param_type'] =='Keyword' ">
                  <div class="col-4">
                     <label class="form-label">Keywords <i class="fa-solid fa-asterisk mandatoryIcon" ></i></label>
                  </div>
                  <div class="col-6">
                    <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                    secondaryPlaceholder="Enter Your Keyword" formControlName="keywords" id="keywords"
                    name="keywords" autocomplete="off" [addOnBlur]="true" [clearOnBlur]="true"
                    [modelAsStrings]="true" theme="minimal" [addOnPaste]="true"
                    [pasteSplitPattern]="splitPattern"></tag-input>
                    <span class="text-danger"
                    *ngIf="qaParamConfigForm.controls['keywords'].invalid && qaParamConfigForm.controls['keywords'].touched">Keyword(s) required.
                  </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4 mt-2">
                    <label class="form-label">Error Type <i class="fa-solid fa-asterisk mandatoryIcon" ></i></label>
                 </div>
                 <div class="col-6 mt-2">
                  <select class="form-select" style="width: auto;" name="error_type_id" formControlName="error_type_id">
                    <!-- <option value="" selected>---Select---</option> -->
                    
                    <ng-container *ngIf="errorTypeList.length > 0">
                       <option value="{{errors['id']}}" *ngFor="let errors of errorTypeList">{{errors['name']}}</option>
                    </ng-container>
                   
                    <!-- <option value="business-critical">Business Critical</option>
                    <option value="customer-critical">Customer Critical</option>
                    <option value="semi-critical">Semi Critical</option>
                    <option value="compliance-critical">Compliance Critical</option>
                     <option value="non-critical">Non-Critical</option>
                    <option value="ding">Ding</option>
                    <option value="na">NA</option> -->
                  </select>
                  <span class="text-danger"
                        *ngIf="qaParamConfigForm.controls['error_type_id'].invalid && qaParamConfigForm.controls['error_type_id'].touched">Error Type is
                        required.
                      </span>
                 </div>
                </div>

                <div class="row mt-1 border py-2">
                   <div class="col-md-4">
                    <div class="form-check form-switch">
                      <label class="form-check-label" for="non_score">Non Score</label>
                      <input class="form-check-input" type="checkbox" id="non_score"
                        name="non_score" formControlName="non_score">
                    </div>
                   </div>
                   <div class="col-md-4">
                    <div class="form-check form-switch">
                      <label class="form-check-label" for="weightage">Weightage</label>
                      <input class="form-check-input" type="checkbox" id="weightage"
                        name="weightage" formControlName="weightage">
                    </div>
                   </div>
                   <div class="col-md-4">
                    <div class="form-check form-switch">
                      <label class="form-check-label" for="weightage">Negative</label>
                      <input class="form-check-input" type="checkbox" id="negative"
                        name="negative" formControlName="negative">
                    </div>
                   </div>
                   <div class="col-md-4">
                    <div class="form-check form-switch">
                      <label class="form-check-label" for="weightage">Auto Score</label>
                      <input class="form-check-input" type="checkbox" id="auto_score"
                        name="auto_score" formControlName="auto_score">
                    </div>
                   </div>
                </div>
                
             </form>
           </div>
           </div>
         </div>
         <div class="modal-footer">
           <div class="form-group topicBtnGroup">
             <button class="btn btn-info cancelBtn" type="reset" data-bs-dismiss="modal" aria-label="Close"
               (click)="exitIconReset()">Cancel</button>
             <button *ngIf="!showButton" class="btn btn-primary updateBtn" type="button"
               (click)="qaParamConfigFormonSubmit()">Save</button>
             <button [disabled]="!qaParamConfigForm.dirty" *ngIf="showButton" class="btn btn-primary updateBtn" type="button"
               (click)="qaParamConfigFormonSubmit()">Update</button>
           </div>
         </div>
       </div>
     </div>        
   </div>


   <!--Mail Autoreply form modal window-->
   <div class="modal fade mailAutoReplyModal" data-bs-backdrop="static" data-bs-keyboard="false" id="MailAutoReply"
   #MailAutoReply>
   <div class="modal-dialog modal-dialog-scrollable modal-lg" [ngClass]="{'full-screen':metricFullscreen}">
     <div class="modal-content">
       <div class="modal-header">
         <h4 class="modal-title">Email Auto Reply</h4>
         <span>
           <i class="fa metricFullscreen" [ngClass]="{'fa-down-left-and-up-right-to-center':metricFullscreen,'fa-up-right-and-down-left-from-center':!metricFullscreen}"  (click)="metricFullscreen = !metricFullscreen"></i>&nbsp;&nbsp;
           <i class="fa-solid fa-xmark exitIcon" #closebutton data-bs-dismiss="modal" aria-label="Close"
           (click)="exitIconReset()"></i>
         </span>
        
       </div>
       <div class="modal-body">
         <div class="col-md-10 offset-md-2">
           <form class="topicForm" [formGroup]="mailAutoReplyConfigForm">
            
        
              <div class="row mt-1">
                <div class="col-3">
                  <label for="topic" class="form-label mandatoryLabel">Template Name
                    <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
                  </label>
                </div>
                <div class="col-6">
                  <span style="display: block; width:100%;">
                    <input type="text" class="form-control" formControlName="template_name" id="template_name" name="template_name"
                      placeholder="Enter your template name" autocomplete="off">
                    </span>
                    <span class="text-danger"
                      *ngIf="mailAutoReplyConfigForm.controls['template_name'].invalid && mailAutoReplyConfigForm.controls['template_name'].touched && mailAutoReplyConfigForm.controls['template_name'].errors?.['whitespace']">Template Name is
                      required.
                    </span>
                     <span class="text-danger"
                      *ngIf="mailAutoReplyConfigForm.controls['template_name'].value !='' && mailAutoReplyConfigForm.controls['template_name'].errors?.['pattern']">Enter valid template name.
                    </span>
                  </div>
                </div>  
             
               
             
                <div class="row mt-1">
                  <div class="col-3">
                     <label class="form-label">Acknowledgement
                      <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
                    </label>
               </div>
               <div class="col-6">
               <select formControlName="trigger_type" class="form-select" (change)="ValidateMailTriggerType($event,mailAutoReplyConfigForm)">
                
                 <option value="immediate">Immediate</option>
                <option value="time_based">Time</option>
               </select>
               <span class="text-danger"
                 *ngIf="mailAutoReplyConfigForm.controls['trigger_type'].invalid && mailAutoReplyConfigForm.controls['trigger_type'].touched">Mail Reply Type is
                 required.
               </span>
               </div>
             </div>
             <div class="row mt-1" #timingElem>
                <div class="col-3">
               <label for="to_email" class="form-label">Trigger Time
                <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
              </label>
               </div>
               <div class="col-6">
              <span style="display: block; width:100%;"><input type="time" formControlName="trigger_time" class="form-control" id="to_time"
                 name="trigger_time" placeholder="time"></span> 
                 <span class="text-danger"
                 *ngIf="mailAutoReplyConfigForm.controls['trigger_time'].touched && mailAutoReplyConfigForm.controls['trigger_time'].invalid">Time is
                 required.
               </span></div>
             </div>

             <div class="row mt-1">
              <div class="col-3">
              <label class="form-label">Reply Method 
                <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
              </label>
              </div>
              <div class="col-6">
              <select formControlName="trigger_condition" class="form-select" (change)="ValidateMailReplyType($event,mailAutoReplyConfigForm)">
                
                <option value="keyword">Keyword Based</option>
               <option value="all_email">All Emails</option>
              </select>
              <span class="text-danger"
                *ngIf="mailAutoReplyConfigForm.controls['trigger_condition'].invalid && mailAutoReplyConfigForm.controls['trigger_condition'].touched">Mail Reply Condition is
                required.
              </span></div>
              </div>

        
              <div class="row mt-1" #keywordTypeElem>
                <div class="col-3">
                <label class="form-label">Reply based On 
                  <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
                </label>
                </div>
                <div class="col-6">
                <select formControlName="keyword_type" class="form-select">
                  
                  <option value="subject">Subject</option>
                 <option value="body">Body</option>
                 <option value="both">Both</option>
                </select>
                <span class="text-danger"
                  *ngIf="mailAutoReplyConfigForm.controls['keyword_type'].invalid && mailAutoReplyConfigForm.controls['keyword_type'].touched">Type is
                  required.
                </span>
                </div>
              </div>

              <div class="row mt-1" #keywordElem>
                <div class="col-3">
                <label class="form-label">Keywords 
                  <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
                </label>
                </div>
                <div class="col-6">
                <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                secondaryPlaceholder="Enter keyword(s)" formControlName="keyword" id="keyword"
                name="keyword" autocomplete="off" [addOnBlur]="true" [clearOnBlur]="true"
                [modelAsStrings]="true" theme="minimal" [addOnPaste]="true"
                [pasteSplitPattern]="splitPattern"></tag-input>
                <span class="text-danger"
                *ngIf="mailAutoReplyConfigForm.controls['keyword'].invalid && mailAutoReplyConfigForm.controls['keyword'].touched">Keyword(s) required.
                  </span></div>
              </div>
          
              <div class="row mt-1">
                <div class="col-3">
                <label class="form-label">Subject 
                  <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
                </label>
                </div>
                <div class="col-6">
               <input type="text" class="form-control" formControlName="subject" id="subject" name="subject"
               placeholder="Enter your subject" autocomplete="off">
                <span class="text-danger"
                  *ngIf="mailAutoReplyConfigForm.controls['subject'].invalid && mailAutoReplyConfigForm.controls['subject'].touched && mailAutoReplyConfigForm.controls['subject'].errors?.['whitespace']">Subject is
                  required.
                </span>
              </div>
              </div>

              <div class="row mt-1">
                <div class="col-3">
                <label class="form-label">Message
                  <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
                </label>
                </div>
                <div class="col-6">
                <angular-editor  formControlName="message_body" id="htmlContent"
               name="message_body" [config]="editorConfig" (ngModelChange)="onChangeEditor($event)"></angular-editor>
                <span class="text-danger"
                  *ngIf="mailAutoReplyConfigForm.controls['message_body'].invalid && mailAutoReplyConfigForm.controls['message_body'].touched && mailAutoReplyConfigForm.controls['message_body'].errors?.['whitespace']">Type is
                  required.
                </span></div>
              </div>

              <div class="row mt-1">
                <div class="col-3">
                <label class="form-label">Reply To
                  <!-- <i class="fa-solid fa-asterisk mandatoryIcon"></i> -->
                </label>
                </div>
                <div class="col-6">
                <select formControlName="reply_to" class="form-select">
                  
                  <option value="sender_only">Sender Only</option>
                 <option value="reply_all">Reply All</option>
                </select>
                <span class="text-danger"
                  *ngIf="mailAutoReplyConfigForm.controls['reply_to'].invalid && mailAutoReplyConfigForm.controls['reply_to'].touched">Type is
                  required.
                </span></div>
              </div>

           </form>
         </div>
        <div class="col-md-10 offset-md-2">
            <div class="row mt-1">
                <div class="col">
                   <div class="required-error">Note: All fields are required.</div>
                 </div>
            </div>
         </div>         
       </div>
       <div class="modal-footer">
         <div class="form-group topicBtnGroup">
           <button class="btn btn-info cancelBtn" type="reset" data-bs-dismiss="modal" aria-label="Close"
             (click)="exitIconReset()">Cancel</button>
           <button  [disabled]="!mailAutoReplyConfigForm.invalid"  *ngIf="!showButton" class="btn btn-primary updateBtn" type="button"
             (click)="mailAutoReplyConfigFormSubmit()">Save</button>
           <button [disabled]="!mailAutoReplyConfigForm.invalid" *ngIf="showButton" class="btn btn-primary updateBtn" type="button"
             (click)="mailAutoReplyConfigFormSubmit()">Update</button>
         </div>
       </div>
     </div>
   </div>
   </div>
      
</div>

